const StepsComponent = (model = [], circular = false, initialStep) => ({
    steps: model,
    circular: circular,
    currentStep: initialStep ? initialStep : model[0].name || model[0],
    get length() {
        return this.steps.length;
    },
    get currentStepIndex() {
        return this.currentIndex + 1;
    },
    get currentIndex() {
        return this.steps.findIndex((step) => {
            let name = step.name || step;
            return name === this.currentStep;
        });
    },
    get firstStepName() {
        const firstNode = this.steps[0];

        return firstNode.name || firstNode;
    },
    get currentStepNode() {
        return this.steps.find((stepNode) => (stepNode.name || stepNode) === this.currentStep);
    },
    isActive(name) {
        return this.currentStep === name;
    },
    transitionTo(to, type = "next", force = false) {
        const destination = to.name || to;
        let isValid = true;

        if (type === "next") {
            isValid = this.validateCurrentStep(this.currentStepNode);
        }

        if (destination && destination !== this.currentStep && isValid) {
            this.activate(destination, force);
        }

        return false;
    },
    transitionToNext() {
        const to = this.pickNext();

        return this.transitionTo(to, "next", true);
    },
    transitionToPrevious() {
        const to = this.pickPrevious();

        return this.transitionTo(to, "prev", true);
    },
    activate(step, force = false) {
        const name = step.name || step;
        const currentIdx = this.currentStepIndex;
        const targetIdx = this.getIndex(name);

        if (targetIdx <= 0) {
            return false;
        }

        if (!force && targetIdx > currentIdx) {
            return false;
        }

        this.currentStep = name;

        return true;
    },
    pickNext() {
        const currentNode = this.steps[this.incrementIndex()];

        if (currentNode) {
            return currentNode.name || currentNode;
        }

        return false;
    },
    pickPrevious() {
        const currentNode = this.steps[this.incrementIndex(-1)];

        if (currentNode) {
            return currentNode.name || currentNode;
        }

        return false;
    },
    incrementIndex(increment = 1) {
        let l = this.length;
        let i = this.currentIndex + increment;

        if (this.circular) {
            i = ((i % l) + l) % l;
        }

        return i;
    },
    getIndex(nameQuery) {
        return (
            this.steps.findIndex((step) => {
                let name = step.name || step;
                return name === nameQuery;
            }) + 1
        );
    },
    isDone(nameQuery) {
        return this.getIndex(nameQuery) < this.currentStepIndex;
    },
    validateCurrentStep(name) {
        var invalid_field = 0;
        if (name === "customer-data") {
            $('.validate-required input, .validate-required select').trigger('validate');

            var shipping = $(".customer-data-inner");
            invalid_field = shipping.find(".woocommerce-invalid-required-field").length;

            var shipping_check = $("#ship-to-different-address-checkbox");
            if (shipping_check.is(":checked")) {
                invalid_field = shipping.find(".woocommerce-invalid-required-field").length;
            }
            if (shipping_check.is(":checked") === false) {
                var shipping_under_billing_step = shipping.find(".woocommerce-shipping-fields");
                invalid_field =
                    invalid_field - shipping_under_billing_step.find(".woocommerce-invalid-required-field").length;
            }

            var extra_fields = shipping
                .find(".woocommerce-shipping-fields")
                .find(">" + ".woocommerce-invalid-required-field").length;
            invalid_field = invalid_field + extra_fields;

            var extra_optional_fields = shipping
                .find(".is-optional.woocommerce-invalid");
            invalid_field = invalid_field + extra_optional_fields.length;

            console.log(invalid_field);
        }

        // if (invalid_field != 0) {
        //   if (active_step != "login") {
        //     next.addClass("disabled").attr("disabled", true);
        //     return false;
        //   } else {
        //     next_step = "billing";
        //   }
        // }
        return invalid_field < 1;
    },
    init() {
        this.$watch("currentStepNode", () => {
            this.validateCurrentStep(this.currentStepNode);
        });

        this.validateCurrentStep(this.currentStepNode);

        $("form.woocommerce-checkout")
            .find(".input-text, select, input:radio, input[type=checkbox]")
            .each(function () {
                var $this = $(this);

                $.each(["input", "validate", "change", "focusout"], function (k, v) {
                    $this.trigger(v);
                });
            });
    },
});

document.addEventListener("alpine:init", () => {
    Alpine.data("steps", StepsComponent);
});
